export const personalInfo = {
  name: "Rohit Majithia",
  heroName: "Captain DevSecOps",
  titles: [
    "DevSecOps Engineer",
    "Kubernetes Security Pro",
    "Cloud Automation Architect"
  ],
  tagline: "Securing Kubernetes at scale. Automating resilient cloud infrastructure. Engineering zero-trust cloud systems.",
  location: "Ahmedabad, India",
  email: "contact@rohitmajithia.com",
  profileImage: "https://customer-assets.emergentagent.com/job_vishals-resume/artifacts/14vjimuf_1000317010.png"
};

export const socialLinks = [
  { name: "LinkedIn", url: "https://www.linkedin.com/in/rohit-majithia-1a4643165/", icon: "Linkedin" },
  { name: "GitHub", url: "https://github.com/rohitsmajithia", icon: "Github" },
  { name: "Instagram", url: "https://www.instagram.com/devsecopswithrohit/", icon: "Instagram" }
];

export const kubernetesShips = [
  { name: "prod-cluster", status: "hardened", color: "#10b981" },
  { name: "staging-cluster", status: "policy enforced", color: "#f59e0b" },
  { name: "secure-eks", status: "zero-trust enabled", color: "#3b82f6" }
];

export const speechBubbles = [
  "Zero Downtime!",
  "Cluster Secured!",
  "Pipeline Deployed!",
  "Zero-Trust Enabled!"
];

// Technical Skills organized by category
export const technicalSkills = {
  cloudPlatforms: {
    title: "Cloud Platforms",
    icon: "☁️",
    color: "#FF9900",
    skills: ["AWS (EC2, EKS, Lambda, S3, RDS)", "Azure (AKS, Functions, DevOps)", "GCP (GKE, Cloud Run)"]
  },
  iac: {
    title: "Infrastructure as Code",
    icon: "🏗️",
    color: "#7B42BC",
    skills: ["Terraform", "CloudFormation", "Ansible", "Pulumi"]
  },
  containers: {
    title: "Containers & Orchestration",
    icon: "🐳",
    color: "#2496ED",
    skills: ["Docker", "Kubernetes", "Helm", "ArgoCD", "Istio"]
  },
  cicd: {
    title: "CI/CD & Automation",
    icon: "🔄",
    color: "#D24939",
    skills: ["Jenkins", "GitHub Actions", "GitLab CI", "Azure DevOps", "Spinnaker"]
  },
  monitoring: {
    title: "Monitoring & Observability",
    icon: "📊",
    color: "#E6522C",
    skills: ["Prometheus", "Grafana", "ELK Stack", "Datadog", "CloudWatch"]
  },
  security: {
    title: "Security & Compliance",
    icon: "🔒",
    color: "#10B981",
    skills: ["Vault", "OPA/Gatekeeper", "Trivy", "SonarQube", "AWS Config"]
  }
};

// Professional Experience - Detailed
export const professionalExperience = [
  {
    id: 1,
    title: "DevOps Engineer",
    company: "Anblicks",
    duration: "Nov 2020 – Present",
    current: true,
    color: "#3b82f6",
    highlights: [
      "Architected and deployed production-grade Kubernetes clusters across AWS EKS and Azure AKS",
      "Implemented GitOps workflows using ArgoCD, reducing deployment time by 70%",
      "Designed multi-region disaster recovery solutions with 99.99% uptime SLA",
      "Built comprehensive CI/CD pipelines with Jenkins, GitHub Actions, and Azure DevOps",
      "Automated infrastructure provisioning with Terraform, managing 500+ resources",
      "Led AWS to Azure migration for enterprise clients with zero downtime",
      "Implemented security-first DevSecOps practices reducing vulnerabilities by 85%",
      "Configured high-availability architectures with auto-scaling and load balancing"
    ],
    technologies: ["Kubernetes", "Terraform", "AWS", "Azure", "Jenkins", "ArgoCD", "Prometheus"]
  },
  {
    id: 2,
    title: "AWS Associate",
    company: "Discus Business Solutions",
    duration: "Feb 2019 – Nov 2020",
    current: false,
    color: "#10b981",
    highlights: [
      "Managed AWS infrastructure for multiple client environments",
      "Implemented automated backup and recovery solutions",
      "Configured VPC networking, security groups, and IAM policies",
      "Deployed and maintained EC2, RDS, and S3 resources",
      "Created CloudWatch dashboards and alerting systems",
      "Assisted in migration of on-premises workloads to AWS cloud"
    ],
    technologies: ["AWS", "EC2", "RDS", "S3", "CloudWatch", "IAM"]
  }
];

// Certifications
export const certifications = [
  {
    name: "AWS Solutions Architect",
    level: "Professional",
    icon: "🏆",
    color: "#FF9900",
    issued: "2024"
  },
  {
    name: "Certified Kubernetes Administrator",
    level: "CKA",
    icon: "⚙️",
    color: "#326CE5",
    issued: "2024"
  },
  {
    name: "HashiCorp Terraform",
    level: "Associate",
    icon: "🏗️",
    color: "#7B42BC",
    issued: "2023"
  },
  {
    name: "Azure Administrator",
    level: "AZ-104",
    icon: "☁️",
    color: "#0078D4",
    issued: "2024"
  },
  {
    name: "AWS Solutions Architect",
    level: "Associate",
    icon: "⭐",
    color: "#FF9900",
    issued: "2023"
  }
];

// Power level skills for visual display
export const skills = [
  { name: "Kubernetes", level: 95, label: "Administrator Level", emoji: "⚙️", color: "#326ce5" },
  { name: "Cloud Architecture", level: 92, label: "Expert", emoji: "☁️", color: "#FF9900" },
  { name: "CI/CD Automation", level: 90, label: "Pipeline Master", emoji: "🔄", color: "#D24939" },
  { name: "Infrastructure as Code", level: 90, label: "Terraform Pro", emoji: "🏗️", color: "#7B42BC" },
  { name: "Security & Compliance", level: 88, label: "DevSecOps", emoji: "🔒", color: "#10b981" }
];

export const experiences = professionalExperience;

export const floatingElements = [
  { name: "Docker", emoji: "🐳", delay: 0 },
  { name: "Kubernetes", emoji: "⚙️", delay: 1 },
  { name: "Terraform", emoji: "🧊", delay: 2 },
  { name: "Cloud", emoji: "☁️", delay: 0.5 },
  { name: "Shield", emoji: "🛡️", delay: 1.5 }
];
